import { SensorsEvent } from './SensorsEvent'

/**
 *   1. 该工具不会影响正常的click事件
 *   2. 若子元素设置了阻止冒泡的click事件，该工具仍会进行计数
 */

export default {
    install: function(app) {
        /**
         * 计数指令
         * @param {string | {id: string, data?: object, selector?: string} | Array<{id: string, data?: object, selector?: string}>}
         *      string：计数事件的 id
         *      {id: String, data?: object, selector?: String}：具有 id 属性的对象，其中对象可包含可选的 selector 选择器字符串和 data 事件参数
         *      [{id: String, data?: object, selector?: String}]}：对象数组，对象定义同上
         * @description 点击事件触发计数事件
         * @example
         * <button v-sensor-count="'10001'">按钮</button>
         * <button v-sensor-count="{id: '10001', data: {name: 'btn'}}">按钮</button>
         * <button v-sensor-count="{id: '10001', selector: '.btn'}">按钮</button>
         * <button v-sensor-count="{id: '10001', selector: '.btn', data: {name: 'btn'}}">按钮</button>
         * <button v-sensor-count="[{id: '10001', selector: '.btn', data: {name: 'btn'}}, {id: '10002', selector: '.btn2', data: {name: 'btn'}}]">按钮</button>
         */
        app.directive("sensor-count", {
            created: function (el, binding) {
                // 该方法主要用于解析入参，添加埋点事件
                function tracking(item) {
                    const { id, selector, data } = item
                    // 判断是否传入id，若没有且非生产环境，则抛出错误
                    if (!item || (typeof item == 'object' && !id)) {
                        if (process.env.NODE_ENV != "production") throw new Error('id is required!')
                        else return
                    }
                    // 判断其他事件参数是否为对象，若不是且非生产环境，则抛出错误
                    if (data && typeof data !== 'object') {
                        if (process.env.NODE_ENV != "production") throw new Error('data must be an object!')
                        else return
                    }
                    let dom = el
                    // 若存在selector属性，则通过selector属性获取对应dom子元素绑定事件
                    if (selector) {
                        dom = el.querySelector(selector)
                    }
                    dom.addEventListener('click', () => {
                        // 判断是否为字符串，若为字符串则直接调用count方法
                        if (typeof item === 'string') {
                            SensorsEvent.count(item)
                        }
                        // 判断有无其他事件参数，若有则携带
                        else if (data) {
                            SensorsEvent.count(id, data)
                        }
                        else {
                            SensorsEvent.count(id)
                        }
                    }, true)
                }
                // 判断传入是否为数组，若为数组循环调用
                Array.isArray(binding.value)
                    ? binding.value.forEach((item) => {
                        tracking(item)
                    }) : tracking(binding.value)
            }
        });

        /**
         * 曝光指令
         * @param {string | {id: string, data?: object, selector?: string} | Array<{id: string, data?: object, selector?: string}>}
         *      string：曝光事件的 id
         *      {id: String, data?: object, selector?: String}：具有 id 属性的对象，其中对象可包含可选的 selector 选择器字符串和 data 事件参数
         *      [{id: String, data?: object, selector?: String}]}：对象数组，对象定义同上
         *      @param {Boolean} multi 是否多次曝光
         * @description 曝光事件触发
         * @example
         * <span v-sensor-expose="'10001'">您好</span>
         * <span v-sensor-expose="{id: '10001', data: {name: 'hello'}}">您好</span>
         * <span v-sensor-expose="{id: '10001', selector: '.hello'}">您好</span>
         * <span v-sensor-expose="{id: '10001', selector: '.hello', data:{name: 'hello'}}">您好</span>
         * <span v-sensor-expose="[{id: '10001', selector: '.hello', data:{name: 'hello'}}, {id: '10002', selector: '.hi', data:{name: 'hi'}]">您好</span>
         * <span v-sensor-expose.multi="'10001'">您好</span>
         */
        app.directive("sensor-expose", {
            created: function (el, binding) {
                function tracking(item) {
                    // 判断是否传入id，若没有且非生产环境，则抛出错误
                    const { id, selector, data } = item
                    if (!item || (typeof item == 'object' && !id)) {
                        if (process.env.NODE_ENV != "production") throw new Error('id is required!')
                        else return
                    }
                    // 判断其他事件参数是否为对象，若不是且非生产环境，则抛出错误
                    if (data && typeof data !== 'object') {
                        if (process.env.NODE_ENV != "production") throw new Error('data must be an object!')
                        else return
                    }
                    let dom = el;
                    if (selector) {
                        dom = el.querySelector(selector)
                    }
                    const observer = new IntersectionObserver((entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                if (typeof item === 'string') {
                                    SensorsEvent.exposure(item)
                                }
                                // 判断有无其他事件参数，若有则携带
                                else if (data) {
                                    SensorsEvent.exposure(id, data)
                                }
                                else {
                                    SensorsEvent.exposure(id)
                                }
                                // 通过判断是否存在multi修饰符，判断是否多次曝光
                                if (!binding.modifiers.multi) observer.unobserve(el);
                            }
                        });
                    });
                    observer.observe(dom);
                }
                // 判断传入是否为数组，若为数组循环调用
                Array.isArray(binding.value)
                    ? binding.value.forEach((item) => {
                        tracking(item)
                    }) : tracking(binding.value)
            }
        });
    }
}